import { MDBBtn, MDBIcon, MDBModalFooter } from 'mdb-react-ui-kit'
import React, { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { editUser } from '../../../apiclients/streamsapi_bridge'

const UserResetPassword = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [passwordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    // const [password2, setPassword2] = useState('');

    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };

    const [passwordVisible3, setPasswordVisible3] = useState(false);
    // const [password3, setPassword3] = useState('');

    const togglePasswordVisibility3 = () => {
        setPasswordVisible3(!passwordVisible3);
    };

    const { register, handleSubmit, formState, setValue, setError, watch, reset } = useForm({
        defaultValues: {
            password: "",
            confirmPassword: "",
        }
    });
    const { errors, isDirty } = formState;
    const password = watch('password');
    const confirmPassword = watch('confirmPassword');


    const onsubmit = async (data) => {
        if (isDirty) {
            let update = {
                reqid: 3,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                agentid: props.useragent,
                password: data.password,
                logined_user: JSON.parse(sessionStorage.getItem("admin_session"))?.logined_user
            };

            console.log(JSON.stringify(update));
            //alert(JSON.stringify(update));
            let saverep = await editUser(update);
            console.log(saverep);
            let saverepeMsg = await saverep.json();
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                props.setSuccessMessage(`Password has reset successfully.`);
                props.onClose();
            }
            else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {
                        if(err.param_name === "logined_user"){
                            props.setErrorMessage(err.message);
                            reset();
                        }
                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();

                        }
                    });
                }
            }
        }
    }


    return (
        <>
            <form>
                {/* <div className="passwordModal">
                <div class="tel-numbers"><strong>{t("currentPassword")}</strong></div>
                <div className="d-flex w-100">
                  <div className="phoneselect w-100">
                    <input
                      type={passwordVisible ? 'text' : 'password'}
                      placeholder="Password"
                      className="form-control w-100"
                      //value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span className="seconds">
                      <a className="cursor-pointer" onClick={togglePasswordVisibility}>
                        <MDBIcon icon={passwordVisible ? 'eye-slash' : 'eye'} />
                      </a>
                    </span>
                  </div>
                </div>
              </div> */}

                <div className="passwordModal mt-0">
                    <div class="tel-numbers"><strong> {t("newPassword")}</strong></div>

                    <div className="d-flex w-100">
                        <div className="phoneselect w-100">
                            <input
                                type={passwordVisible2 ? 'text' : 'password'}
                                placeholder="Password"
                                className="form-control w-100"
                                {...register("password", {
                                    required: "Password required.",
                                    pattern: {
                                        value: /^(?=.*[a-zA-Z])(?=.*\d)(?!.*\s)(?=.*[!@%#$*?|+\-_])[A-Za-z\d!@%#$*?|+\-_]{8,20}$/,
                                        message: 'Invalid password format',
                                    },

                                })}
                            //onChange={(e) => setPassword2(e.target.value)}
                            />
                            <span className="seconds">
                                <a className="cursor-pointer" onClick={togglePasswordVisibility2}>
                                    <MDBIcon icon={passwordVisible2 ? 'eye' : 'eye-slash'} />
                                </a>
                            </span>
                            {errors.password && (
                                <p className="text-danger">{errors.password.message}</p>
                            )}
                        </div>
                    </div>

                </div>

                <div className="passwordModal mt-3">
                    <div class="tel-numbers"><strong> {t("confirmPassword")}</strong></div>
                    <div className="d-flex w-100">
                        <div className="phoneselect w-100">
                            <input
                                type={passwordVisible3 ? 'text' : 'password'}
                                placeholder="Password"
                                className="form-control w-100"
                                {...register("confirmPassword", {
                                    required: "Confirmation password is required.",
                                    validate: (value) => value === password || "Passwords do not match",

                                })}
                            // onChange={(e) => setPassword3(e.target.value)}
                            />
                            <span className="seconds">
                                <a className="cursor-pointer" onClick={togglePasswordVisibility3}>
                                    <MDBIcon icon={passwordVisible3 ? 'eye' : 'eye-slash'} />
                                </a>
                            </span>
                            {errors.confirmPassword && (
                                <p className="text-danger">{errors.confirmPassword.message}</p>
                            )}
                        </div>
                    </div>
                </div>

                <h6 className="mt-3">
                    The password must contain:
                </h6>
                <ul className="mb-2">
                    <li>The password must be at least 8 characters long and max of 20 characters long.</li>
                    <li>One alphabet [a-z, A-Z].</li>
                    <li>One numeric character [0-9].</li>
                </ul>
                <p className="mb-2">
                    <b>Note</b>: It is not mandatory that your password must contain special characters but, if you want to include, please select from this set:! @ % # $ * ? | - + _ =
                </p>
                <h6>The password must not:</h6>
                <ul>
                    <li>Contain Spaces</li>
                    <li>Contain your login ID.</li>
                </ul>

                <div style={{ display: "none" }}>
                    <button ref = {ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                        {t("ResetPassword")}</button>
                </div>

                {/* <MDBModalFooter>
                    <MDBBtn color='secondary' onClick={(e) => props.onClose(e)}>
                        Close
                    </MDBBtn>
                    <MDBBtn
                     onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(onsubmit)();}}
                    >{t("ResetPassword")}</MDBBtn>
                </MDBModalFooter> */}
            </form>

        </>
    )
});

export default UserResetPassword
